
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MultiverseBubblesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(15 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                const r = (50 + this.pseudoRandom(i + 2) * 150) * scale * (1 / (layerIndex + 1));
                
                // Floating motion
                const dx = Math.sin(curTime * 0.3 + i) * 50;
                const dy = Math.cos(curTime * 0.3 + i) * 50;
                
                ctx.save();
                ctx.globalAlpha *= 0.3;
                ctx.beginPath();
                ctx.arc(rx + dx, ry + dy, r, 0, Math.PI * 2);
                ctx.stroke();
                
                // Subtle inner pattern
                ctx.globalAlpha *= 0.2;
                ctx.beginPath();
                ctx.arc(rx + dx, ry + dy, r * 0.8, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
